import { motion } from "framer-motion";
import { MaskLines, FadeIn } from "./Reveal";

export default function PageHero({ eyebrow, lines, sub, gradientLast = true, children }) {
    return (
        <section className="relative overflow-hidden pt-36 pb-14 sm:pt-44 sm:pb-16">
            <div
                className="absolute inset-0 pointer-events-none"
                style={{ background: "radial-gradient(60% 50% at 70% 0%, rgba(10,95,194,0.22) 0%, rgba(11,15,23,0) 70%)" }}
            />
            <div className="wrap relative">
                <FadeIn delay={0.05}>
                    <p className="eyebrow mb-6">{eyebrow}</p>
                </FadeIn>
                <h1 className="font-display font-bold tracking-[-0.02em] leading-[1.06] text-[clamp(2.1rem,5vw,3.8rem)] text-white">
                    <MaskLines lines={lines} gradientLast={gradientLast} />
                </h1>
                {sub && (
                    <FadeIn delay={0.55}>
                        <p className="mt-6 max-w-2xl lead">{sub}</p>
                    </FadeIn>
                )}
                {children}
            </div>
        </section>
    );
}
